module.exports = __webpack_public_path__ + "static/media/ic_status_archive_outlined.0cb2aac0.svg";